module.exports = __webpack_public_path__ + "static/techology-list-a54ac7ae5625514fb26501bd969475f0.jpg";